"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var toastr = require("toastr");
function toaster(message, type) {
    if (type === void 0) { type = null; }
    if (type === "error") {
        return toastr.error(message);
    }
    return toastr.success(message);
}
exports.default = toaster;
